var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueCloseButtonIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 1.33398C4.31325 1.33398 1.33325 4.31398 1.33325 8.00065C1.33325 11.6873 4.31325 14.6673 7.99992 14.6673C11.6866 14.6673 14.6666 11.6873 14.6666 8.00065C14.6666 4.31398 11.6866 1.33398 7.99992 1.33398ZM7.99992 13.334C5.05992 13.334 2.66659 10.9407 2.66659 8.00065C2.66659 5.06065 5.05992 2.66732 7.99992 2.66732C10.9399 2.66732 13.3333 5.06065 13.3333 8.00065C13.3333 10.9407 10.9399 13.334 7.99992 13.334ZM10.3933 4.66732L7.99992 7.06065L5.60659 4.66732L4.66659 5.60732L7.05992 8.00065L4.66659 10.394L5.60659 11.334L7.99992 8.94065L10.3933 11.334L11.3333 10.394L8.93992 8.00065L11.3333 5.60732L10.3933 4.66732Z",
    fill: "#5899EF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCloseButtonIcon);
export default __webpack_public_path__ + "static/media/blue-close-button-icon.28e686ef.svg";
export { ForwardRef as ReactComponent };